// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M11.62 14.91Q11.45 14.85 11.29 14.7L6.69 10.1Q6.41 9.82 6.41 9.4T6.69 8.7 7.39 8.42 8.09 8.7L11.99 12.6 15.89 8.7Q16.17 8.42 16.59 8.42T17.29 8.7 17.57 9.4 17.29 10.1L12.69 14.7Q12.54 14.85 12.36 14.91T11.98 14.97 11.6 14.91"/>';

/** Chevron Down (arrows). */
const icon: IconData = {
  id: "chevron-down",
  name: "Chevron Down",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M12 15.4L6 9.4 7.4 8 12 12.6 16.6 8 18 9.4Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M11.62 14.91Q11.45 14.85 11.29 14.7L6.69 10.1Q6.41 9.82 6.41 9.4T6.69 8.7 7.39 8.42 8.09 8.7L11.99 12.6 15.89 8.7Q16.17 8.42 16.59 8.42T17.29 8.7 17.57 9.4 17.29 10.1L12.69 14.7Q12.54 14.85 12.36 14.91T11.98 14.97 11.6 14.91"/></g><path d="M11.62 14.91Q11.45 14.85 11.29 14.7L6.69 10.1Q6.41 9.82 6.41 9.4T6.69 8.7 7.39 8.42 8.09 8.7L11.99 12.6 15.89 8.7Q16.17 8.42 16.59 8.42T17.29 8.7 17.57 9.4 17.29 10.1L12.69 14.7Q12.54 14.85 12.36 14.91T11.98 14.97 11.6 14.91"/>',
    },
  },
  animation: () => import("../animations/chevron-down.js"),
};

export default icon;
